import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  file_type: [],
  total_volume: 0,
  total_volume_bytes: 0,
  files: JSON.parse(localStorage.getItem("files")),
  sub_files: JSON.parse(localStorage.getItem("file")),
  pagination_data: null, // New field for pagination
  enc_key: [],
};

const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    setFileType: (state, action) => {
      state.file_type = action.payload;
    },
    setTotalVolume: (state, action) => {
      state.total_volume = action.payload;
    },
    setTotalVolumeInBytes: (state, action) => {
      state.total_volume_bytes = action.payload;
    },
    setFiles: (state, action) => {
      localStorage.setItem("files", JSON.stringify(action.payload));
      state.files = action.payload;
    },
    setSubFiles: (state, action) => {
      localStorage.setItem("file", JSON.stringify(action.payload));
      state.sub_files = action.payload;
    },
    // New action for appending files (for pagination)
    appendSubFiles: (state, action) => {
      const newFiles = [...(state.sub_files || []), ...action.payload];
      localStorage.setItem("file", JSON.stringify(newFiles));
      state.sub_files = newFiles;
    },
    // New action for pagination data
    setPaginationData: (state, action) => {
      state.pagination_data = action.payload;
    },
    setEncKey: (state, action) => {
      state.enc_key = action.payload;
    },
    // Reset sub_files (useful when starting fresh)
    resetSubFiles: (state) => {
      localStorage.removeItem("file");
      state.sub_files = null;
      state.pagination_data = null;
    },
  },
});

export const {
  setFileType,
  setTotalVolume,
  setFiles,
  setSubFiles,
  appendSubFiles,
  setPaginationData,
  setEncKey,
  resetSubFiles,
  setTotalVolumeInBytes,
} = fileSlice.actions;

export default fileSlice.reducer;
